import { render, staticRenderFns } from "./teacherGroup.vue?vue&type=template&id=aa5008fc"
import script from "./teacherGroup.vue?vue&type=script&lang=js"
export * from "./teacherGroup.vue?vue&type=script&lang=js"
import style0 from "./teacherGroup.vue?vue&type=style&index=0&id=aa5008fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports